module.exports = function() {
  return new Worker(__webpack_public_path__ + "344b7409eb185a6672c9.worker.js");
};